module.exports = __webpack_public_path__ + "7a239c2aeec25b93f813059a78633796.pdf";